import * as React from 'react';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';


export default function Loading({open, variant = 'page'}) {
  if (variant === 'local') {
    if (!open) return null;

    return (
      <div className="absolute inset-0 z-50 flex items-center justify-center bg-white/70">
        <CircularProgress sx={{ color: '#7442C8' }} />
      </div>
    );
  }

  return (
    <div>
      
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={open}
        
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </div>
  );
}
